export const MAX_REVIEW_RECIPES = 8;
export const MAX_RANDOM_RECIPES = 6;
export const MAX_DROPDOWN_ITEMS = 5;
export const BASE_URL = "https://ourhappymeals.netlify.app";
export const ITEMS_PER_PAGE = 16;
